import React from "react";
import { Box } from "@mui/material";
import useInView from "../hooks/useInView";

/**
 * Reveal — wraps any content with a scroll-triggered entrance animation.
 *
 * variant:
 *   "fadeUp"    → opacity + translateY (headings, paragraphs)
 *   "fadeScale" → opacity + scale      (cards, images)
 *
 * delay   — ms offset, for stagger effects
 * duration — transition length in ms (default 600)
 */
const Reveal = ({
  children,
  variant = "fadeUp",
  delay = 0,
  duration = 600,
  sx = {},
  ...props
}) => {
  const [ref, inView] = useInView();

  const styles = (() => {
    const base = {
      willChange: "opacity, transform",
      transition: `opacity ${duration}ms cubic-bezier(0.4,0,0.2,1) ${delay}ms,
                   transform ${duration}ms cubic-bezier(0.4,0,0.2,1) ${delay}ms`,
    };

    switch (variant) {
      case "fadeScale":
        return {
          ...base,
          opacity: inView ? 1 : 0,
          transform: inView ? "scale(1) translateY(0)" : "scale(0.95) translateY(14px)",
        };
      case "fadeUp":
      default:
        return {
          ...base,
          opacity: inView ? 1 : 0,
          transform: inView ? "translateY(0)" : "translateY(28px)",
        };
    }
  })();

  return (
    <Box ref={ref} sx={{ ...styles, ...sx }} {...props}>
      {children}
    </Box>
  );
};

export default Reveal;
